/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useMemo, useRef } from "react";
import { InfoFormDefault, TimesIcon } from "~misc/icons";

import { Field, Form, Formik } from "formik";
import { Checkbox, FormControl, FormLabel, Input, Tooltip } from "@chakra-ui/react";
import Select from "~components/Form/components/Select";
import "../../styles.scss";
import useSimulatorsCreateProductForm from "../../hooks/useSimulatorsCreateProductForm";
import { useState } from "react";
import useModalPrice from "~components/Modal/hooks/useModalPrice";
import ModalCreateProduct from "../modals/ModalCreateProduct";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import { useNavigate, useParams } from "react-router-dom";
import useFamiliaProduto from "~/fetchs/useFamiliaProduto";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import PercentageInput from "~components/Form/components/PercentageInput";
import { initialPath } from "~misc/paths";
import useFilial from "~/fetchs/useFilial";
import usePrazoPagamento from "~/fetchs/usePrazoPagamento";
import useCliente from "~/fetchs/useCliente";
import usePrecoCliente, { ArrumaDesconto } from "~/fetchs/usePrecoCliente";
import usePrecoRegra from "~/fetchs/usePrecoRegra";
import { getLocalStorage, removeLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";
import { money } from "~hooks/useHelpers";
import useCalculateDiscount from "~pages/Simulators/hooks/useCalculateDiscount";
import CurrencyInputAlternate from "~components/Form/components/CurrencyInputAlternate";
import { Spinner } from "@chakra-ui/react";
import useProdutoFilialPrecoRegraMicrorregiao from "~/fetchs/useProdutoFilialPrecoRegraMicrorregiao";
import useProdutoFilial from "~/fetchs/useProdutoFilial";
import usePrecoProduto from "~/fetchs/usePrecoProduto";
import useTipoCondicao from "~/fetchs/useTipoCondicao";
import Multiselect from "multiselect-react-dropdown";
import _ from "lodash";
import PercentageSpc from "~components/Form/components/PercentageSpc";
import ModalResponse from "~components/Modal/ModalResponse";
import useSubGrupoMaterial from "~/fetchs/useSubGrupoMaterial";


const NoInfoOverlay = ({ name, setShowOverlay }) => {
  const overlayRef = useRef(null);

  const handleClick = () => {
    setShowOverlay((prev) => ({
      ...prev,
      [name]: false,
    }));

    overlayRef.current?.parentElement.children[0].getElementsByTagName("input")[0].focus();
  };

  return (
    <div className="absolute w-full top-0 bg-[#E6E6E6]" ref={overlayRef}>
      <Input onClick={handleClick} className="text-center" style={{ fontSize: 14 }} readOnly />
    </div>
  );
};


const ProposalTypeSection = ({ clickProposta, manterRegra, faixa, condicaoEspecial, errors, touched }) => (
  <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
    <div className="sm:flex justify-between py-3">
      <h2 className="text-2xl font-bold title pb-6">Tipo de Proposta</h2>
    </div>
    <div className="sm:flex sm:justify-between sm:items-center concorrente proposta gap-x-4 mt-4">
      {[
        { name: "manter", label: "Manter\nno preço regra", checked: manterRegra },
        { name: "faixa", label: "Faixa", checked: faixa, tooltip: "Desconto percentual que se aplica ao cliente e ao material, independente do centro e do modal escolhidos." },
        { name: "especial", label: "Condição Especial\nde Preço e Prazo", checked: condicaoEspecial, tooltip: "Desconto de preço ou prazo que se aplica especificamente a um cliente, material, centro e modal escolhidos." }
      ].map(({ name, label, checked, tooltip }) => (
        <div key={name} className="sm:w-1/3 mt-4 sm:mt-0 flex items-center gap-x-2">
          <label className="flex items-center space-x-2">
            <Field
              type="checkbox"
              name={`condicao.${name}`}
              className=""
              onClick={() => clickProposta(name)}
              checked={checked}
            />
          </label>
          <span className="text-lg font-bold whitespace-pre-line">{label}</span>
          {tooltip && (
            <Tooltip label={tooltip}>
              <InfoFormDefault />
            </Tooltip>
          )}
        </div>
      ))}
    </div>
    {errors.condicao && touched.condicao && (
      <p style={{ color: "red", fontSize: "14px" }}>{errors.condicao}</p>
    )}
  </div>
);


const ProductFormFields = ({
  optionFiliais, onChangeFilial, filialSelect,
  optionGruposProduto, onChangeGrupoProduto, grupoProdutoSelect,
  optionProdutos, onChangeProduto, produtoSelect,
  errors, touched
}) => (
  <FormControl className="flex container gap-x-6 pt-6">
    {[
      { label: "Centro/Filial:", name: "filialId", options: optionFiliais, onChange: onChangeFilial, selectProps: filialSelect },
      { label: "Grupo de Produto:", name: "grupoProduto", options: optionGruposProduto, onChange: onChangeGrupoProduto, selectProps: grupoProdutoSelect },
      { label: "Produto:", name: "produto", options: optionProdutos, onChange: onChangeProduto, selectProps: produtoSelect }
    ].map(({ label, name, options, onChange, selectProps }) => (
      <div key={name} className="w-[100%]">
        <FormLabel className="select-label">{label}</FormLabel>
        <Select
          name={name}
          label=""
          placeholder={name === "produto" ? "Buscar Produto" : name === "grupoProduto" ? "Buscar Grupo Produto" : ""}
          options={options}
          noOptionsMessage={`${label.split(':')[0]} não encontrado`}
          onChange={onChange}
          errors={errors[name]}
          touched={touched[name]}
          setFieldValue={() => {}}
          isDisabled
          {...selectProps}
        />
      </div>
    ))}
  </FormControl>
);

  const processProdutoReplication = async (values, replicationData, precosRegraDisponiveis, produtosReplicacao, filiais, processaProduto, calculateDiscountFaixa,descontoFob, descontoCif) => {
    const promises = [];
    const prodsReplicacao = replicationData.produtoReplicacao?.split(',') || [];

    precosRegraDisponiveis?.forEach(precoProdutoRepli => {
      prodsReplicacao?.forEach(pReplicacao => {
        const idProdutoReplica = parseInt(pReplicacao);
        const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == idProdutoReplica);
        const filial = (filiais || []).find((opt) => opt.id == precoProdutoRepli.filialId);

        if (optProdutoReplicacao && precoProdutoRepli.produtoId === idProdutoReplica && filial) {
          const promise = processaProduto({
            ...values,
            precoFinalFob: calculateDiscountFaixa(precoProdutoRepli.valorPrecoFOB, descontoFob),
            precoFinalCif: calculateDiscountFaixa(precoProdutoRepli.valorPrecoCIF, descontoCif),
            precoRegraFob: precoProdutoRepli.valorPrecoFOB,
            precoRegraCif: precoProdutoRepli.valorPrecoCIF,
            produtoId: precoProdutoRepli.produtoId,
            grupoProdutoId: optProdutoReplicacao.grupoMaterialId
          }, optProdutoReplicacao, filial, true);
          promises.push(promise);
        }
      });
    });

    await Promise.all(promises);
  };



    const processCentroReplication = async (values, precosRegraDisponiveis, replicationData, produtoSelecionado,precoFinalFob,precoFinalCif,  filiais, produtosReplicacao, processaProduto, descontoFob, descontoCif) => {
    const promises = [];
    const filteredPrecosProdutos = precosRegraDisponiveis?.filter(pp => {
      const centroReplicacao = replicationData.filiaisReplicacao?.split(',')?.map(fr => parseInt(fr));
      return pp.produtoId == produtoSelecionado && centroReplicacao?.includes(pp.filialId);
    }) || [];

    filteredPrecosProdutos?.forEach(precoCentroRepli => {
      const centroReplicacao = replicationData.filiaisReplicacao?.split(',') || [];

      centroReplicacao?.forEach(fReplicacao => {
        const idCentroReplica = parseInt(fReplicacao);
        const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == produtoSelecionado);
        const filial = (filiais || []).find((opt) => opt.id == idCentroReplica);

        if (optProdutoReplicacao && precoCentroRepli.filialId === idCentroReplica && filial) {
          const promise = processaProduto({
            ...values,
            precoFinalFob: descontoFob ? precoFinalFob : precoCentroRepli.valorPrecoFOB,
            precoFinalCif: descontoCif ? precoFinalCif : precoCentroRepli.valorPrecoCIF,
            precoRegraFob: precoCentroRepli.valorPrecoFOB,
            precoRegraCif: precoCentroRepli.valorPrecoCIF,
            produtoId: produtoSelecionado,
            grupoProdutoId: optProdutoReplicacao.grupoMaterialId
          }, optProdutoReplicacao, filial, true);
          promises.push(promise);
        }
      });
    });

    await Promise.all(promises);
  };

const NovoProdutoFormulario = () => {
  const navigate = useNavigate();
  const formikRef = useRef();
  const { parameter: idCliente } = useParams();

  const [loading, setLoading] = useState(false);
  const [isOpenModalResponse, setIsOpenModalResponse] = useState(false);
  const [temSobreposicao, setTemSobreposicao] = useState(false);
  const [carregouPrecoAprovadoCliente, setCarregouPrecoAprovadoCliente] = useState(false);
  const [manterRegra, setManterRegra] = useState(true);
  const [faixa, setFaixa] = useState(false);
  const [condicaoEspecial, setCondicaoEspecial] = useState(false);

  const [locationData, setLocationData] = useState({
    microrregiaoId: null,
    clusterId: null,
    cidadeId: null,
    filialId: null
  });

  const [showOverlay, setShowOverlay] = useState({
    fob: false,
    cif: false,
  });

  const [replicationData, setReplicationData] = useState({
    produtoReplicacao: "",
    filiaisReplicacao: ""
  });


  const { cliente } = useCliente(idCliente);
  const { validationSchema, initialValues } = useSimulatorsCreateProductForm();
  const { isModalOpenPrice, closeModalPrice } = useModalPrice();

  const {
    descontoCif, setDescontoCif,
    descontoFob, setDescontoFob,
    precoFinalCif, setPrecoFinalCif,
    precoFinalFob, setPrecoFinalFob,
    precoRegraCif, setPrecoRegraCif,
    precoRegraFob, setPrecoRegraFob,
    calculateDiscountFaixa,
    setIsEditingDesconto,
    setIsEditingPrecoFinal
  } = useCalculateDiscount(faixa, condicaoEspecial);


  const { precosRegraDisponiveis, filiaisDisponiveis, gruposMateriaisDisponiveis, familiasDisponiveis, produtosDisponiveis } = useProdutoFilialPrecoRegraMicrorregiao({ microrregiaoId: locationData.microrregiaoId });

  const { filiais, optionFiliais, onChangeFilial: onChangeFilialReplicacao, onChangeFilial, filialSelect, SetSelectFilial } = useFilial({ formikRef, filiaisDisponiveis });

  const { gruposProduto, optionGruposProduto, grupoProdutoSelect, onChangeGrupoProduto, grupoProduto, SetSelectGrupoProduto } = useGrupoProduto({ formikRef, camposOpt: ["nome"] });

  const { produtos, produto: produtoSelecionado, optionProdutos, produtoSelect, onChangeProduto, SetSelectProduto, getIndexDBProdutoSimulacao, produtoSimulacao } = useProduto({ grupoProduto, formikRef, name: "produtoId", camposOpt: ["descricaoProduto"] });

  const { produtoNaFilial } = useProdutoFilial({ filial: locationData.filialId, produtoId: produtoSimulacao.produtoId });

  const { precoRegra } = usePrecoRegra({
    produto: produtoSimulacao?.produtoId,
    filial: locationData.filialId,
    microrregiao: locationData.microrregiaoId,
    cluster: locationData.clusterId,
    cidade: locationData.cidadeId,
    setLoading,
  });

  // Replication hooks
  const { optionGruposProduto: optionGruposProdutoReplicacao, grupoProdutoSelect: grupoProdutoReplicacaoSelect, onChangeGrupoProduto: onChangeGrupoProdutoReplicacao, grupoProduto: grupoProdutoReplicacao } = useGrupoProduto({ formikRef, name: "grupoProdutoReplicacaoId", filiais, filial: locationData.filialId, gruposDisponiveis: gruposMateriaisDisponiveis, camposOpt: ["nome"], replicacao: true });

  const { familiasProduto: familiasProdutoReplicacao } = useFamiliaProduto({ formikRef, name: "familiaProdutoReplicacaoId", familiasDisponiveis, replicacao: true });

  const { subGrupoMaterial: subGrupoMaterialReplicacao, optionSubGrupoMateriais, subGrupoMaterialSelect, onChangeSubGrupoMaterial } = useSubGrupoMaterial({ formikRef, filialForm: locationData.filialId, name: 'subGrupoMaterialReplicacaoId', gruposMateriaisDisponiveis, replicacao: true });

  const { produtos: produtosReplicacao, optionProdutos: optionReplicacaoProdutos, produtoSelect: produtoReplicacaoSelect, onChangeProduto: onChangeProdutoReplicacao } = useProduto({ filialForm: locationData.filialId, produtosDisponiveis, formikRef, type: 'geral', name: "produtoReplicacaoId", camposOpt: ['codigo', "descricaoProduto"], typeOptions: 'multi', replicacao: true });

  const { optionGruposCentralizadores, onChangeGrupoCentralizador, grupoCentralizadorSelect } = useGrupoCentralizador(formikRef, "grupoCentralizadorReplicacaoId");

  const { prazoPagamentos, onChangePrazoPagamento, prazoPagamentoSelect, optionPrazosPagamento } = usePrazoPagamento(formikRef);
  const { tipoCondicoes } = useTipoCondicao(null);
  const { precoCliente } = usePrecoCliente({ id: idCliente });


  const optionFiliaisReplicacao = useMemo(() => {
    return (optionFiliais || []).filter((optFilial) => {
      const precosProdutoCheck = (precosRegraDisponiveis || []).some(pp => pp.produtoId == produtoSelecionado && pp.filialId === optFilial.value);
      return (optFilial.value !== locationData.filialId && precosProdutoCheck);
    });
  }, [optionFiliais, precosRegraDisponiveis, produtoSelecionado, locationData.filialId]);


  const handleProdutoReplicacaoMulti = (e) => {
    const produtosIds = e?.map(pReplicacao => pReplicacao.value).join(',') || "";
    setReplicationData(prev => ({ ...prev, produtoReplicacao: produtosIds }));
    onChangeProdutoReplicacao({ label: "Produtos Selecionados", value: produtosIds });
  };

  const handleFilialReplicacaoMulti = (e) => {
    const filiaisIds = e?.map(fReplicacao => fReplicacao.value).join(',') || "";
    setReplicationData(prev => ({ ...prev, filiaisReplicacao: filiaisIds }));
    onChangeFilialReplicacao({ label: "Filiais Selecionadas", value: filiaisIds });
  };

  const handleChangeEnviaPrazo = (e, type = "cif") => {
    formikRef.current?.setFieldValue(`prazo${type.charAt(0).toUpperCase() + type.slice(1)}`, e.target.checked);
  };

  const handleProposalTypeClick = (name, resetValue = true) => {
    formikRef.current.setFieldValue("condicao.faixa", false);
    formikRef.current.setFieldValue("condicao.manter", false);
    formikRef.current.setFieldValue("condicao.especial", false);
    formikRef.current.setFieldValue("condicao." + name, true);

    if ((name == "faixa" && resetValue) || name == "manter") {
      setDescontoCif(0);
      setDescontoFob(0);
    }

    if (name == "especial") {
      setShowOverlay({ fob: true, cif: true });
      if (descontoCif || descontoFob !== 0) {
        setDescontoFob(0);
        setDescontoCif(0);
        setPrecoFinalFob(0);
        setPrecoFinalCif(0);
      }

      ['grupoProdutoReplicacaoBool', 'subGrupoMaterialReplicacaoBool', 'produtoReplicacaoBool', 'grupoCentralizadorReplicacaoBool'].forEach(field => {
        formikRef.current?.setFieldValue(field, false);
      });
    } else {
      setShowOverlay({ fob: false, cif: false });
      onChangePrazoPagamento({ label: '', value: 0 });
      formikRef.current?.setFieldValue("prazoCif", false);
      formikRef.current?.setFieldValue("prazoFob", false);
    }

    setFaixa(name === "faixa");
    setCondicaoEspecial(name === "especial");
    setManterRegra(name === "manter");
  };


  useEffect(() => {
    if (cliente) {
      setLocationData({
        microrregiaoId: cliente.microrregiaoId,
        clusterId: cliente.clusterId,
        cidadeId: cliente?.endereco?.cidade?.id,
        filialId: locationData.filialId
      });
    }
  }, [cliente]);

  useEffect(() => {
    getIndexDBProdutoSimulacao(idCliente);
  }, []);

  useEffect(() => {
    if (Object.keys(produtoSimulacao).length > 0) {
      SetSelectProduto(produtoSimulacao.produtoId);
      SetSelectGrupoProduto(produtoSimulacao.grupoProdutoId);
      SetSelectFilial(produtoSimulacao.filialId);
      setLocationData(prev => ({ ...prev, filialId: produtoSimulacao.filialId }));
    }
  }, [produtoSimulacao, optionProdutos, optionGruposProduto]);

  useEffect(() => {
    if (precoRegra) {
      setPrecoRegraFob(precoRegra?.valorPrecoFOB);
      setPrecoRegraCif(precoRegra?.valorPrecoCIF);
      setPrecoFinalFob(precoRegra?.valorPrecoFOB);
      setPrecoFinalCif(precoRegra?.valorPrecoCIF);
    }
  }, [precoRegra]);




const getTipoCondicaoId = (tipoCondicoes, nome) =>
  tipoCondicoes?.find(e => e.nome.toLowerCase() === nome)?.id;

const ordenarPrecos = (precos = []) =>
  [...precos].sort((a, b) => b - a);

const verificarSobreposicao = (preco) => {
  if (!preco?.faixa) return false;

  const faixa = parseFloat(preco.faixa) || 0;
  const cif = parseFloat(preco.precoEspecialCIF) || 0;
  const fob = parseFloat(preco.precoEspecialFOB) || 0;

  return faixa !== 0 && (cif !== 0 || fob !== 0);
};

const aplicarFormik = (campo, valor, formikRef) => {
  if (valor) formikRef.current?.setFieldValue(campo, valor);
};


const aplicarCondicaoEspecial = ({
  preco,
  precoRegraCif,
  precoRegraFob,
  formikRef,
  setPrecoFinalCif,
  setPrecoFinalFob,
  setDescontoCif,
  setDescontoFob,
  setShowOverlay,
}) => {
  if (preco.desconto) {
    const d = ArrumaDesconto(preco.desconto);
    setDescontoCif(d);
    setDescontoFob(d);
  }

  if (preco.precoFinalCIF) {
    setPrecoFinalCif(preco.precoFinalCIF);
    aplicarFormik("precoFinalCif", preco.precoFinalCIF, formikRef);

    if (precoRegraCif) {
      const d = ((preco.precoFinalCIF / precoRegraCif) - 1) * 100;
      setDescontoCif(d.toFixed(1));
    }
  }

  if (preco.precoFinalFOB) {
    setPrecoFinalFob(preco.precoFinalFOB);
    aplicarFormik("precoFinalFob", preco.precoFinalFOB, formikRef);

    if (precoRegraFob) {
      const d = ((preco.precoFinalFOB / precoRegraFob) - 1) * 100;
      setDescontoFob(d.toFixed(1));
    }
  }

  setShowOverlay({ cif: false, fob: false });
};

const aplicarFaixa = ({
  precoFaixa,
  precoCE,
  formikRef,
  setPrecoFinalCif,
  setPrecoFinalFob,
  setDescontoCif,
  setDescontoFob,
}) => {
  const usarCE = precoCE?.faixa && precoCE.faixa !== "0.00";
  const desconto = usarCE ? precoCE.faixa : precoFaixa.faixa;

  setDescontoCif(ArrumaDesconto(desconto));
  setDescontoFob(ArrumaDesconto(desconto));

  const cif = usarCE ? precoCE.precoFinalCIF : precoFaixa.precoFinalCIF;
  const fob = usarCE ? precoCE.precoFinalFOB : precoFaixa.precoFinalFOB;

  if (cif) {
    setPrecoFinalCif(cif);
    aplicarFormik("precoFinalCif", cif, formikRef);
  }

  if (fob) {
    setPrecoFinalFob(fob);
    aplicarFormik("precoFinalFob", fob, formikRef);
  }
};


useEffect(() => {
  if (!precoCliente || !tipoCondicoes) return;

  const tipoFaixaId = getTipoCondicaoId(tipoCondicoes, "faixa");
  const tipoCEId = getTipoCondicaoId(tipoCondicoes, "condição especial");

  const precos = ordenarPrecos(precoCliente);

  const precoFaixa = precos.find(
    pc =>
      pc.tipoCondicaoId === tipoFaixaId &&
      (pc.produtoFilialId === produtoNaFilial?.id ||
       pc.produtoId === produtoNaFilial?.produtoId)
  );

  const precoCE = precos.find(
    pc =>
      pc.tipoCondicaoId === tipoCEId &&
      pc.produtoFilialId === produtoNaFilial?.id
  );

  if (verificarSobreposicao(precoCE) || verificarSobreposicao(precoFaixa)) {
    setTemSobreposicao(true);
  }

  let aprovado = false;

  const podeUsarCE =
    (precoCE?.precoFinalCIF || precoCE?.precoFinalFOB) &&
    (condicaoEspecial || !carregouPrecoAprovadoCliente);

  const podeUsarFaixa =
    ((precoFaixa?.faixa && precoFaixa.faixa !== "0.00") ||
     (precoCE?.faixa && precoCE.faixa !== "0.00")) &&
    (faixa || !carregouPrecoAprovadoCliente);

  if (podeUsarCE) {
    aplicarCondicaoEspecial({
      preco: precoCE,
      precoRegraCif,
      precoRegraFob,
      formikRef,
      setPrecoFinalCif,
      setPrecoFinalFob,
      setDescontoCif,
      setDescontoFob,
      setShowOverlay,
    });

    if (!carregouPrecoAprovadoCliente) {
      setFaixa(false);
      setCondicaoEspecial(true);
      setManterRegra(false);
      aprovado = true;
    }

  } else if (podeUsarFaixa) {
    aplicarFaixa({
      precoFaixa,
      precoCE,
      formikRef,
      setPrecoFinalCif,
      setPrecoFinalFob,
      setDescontoCif,
      setDescontoFob,
    });

    if (!carregouPrecoAprovadoCliente) {
      setFaixa(true);
      setCondicaoEspecial(false);
      setManterRegra(false);
      aprovado = true;
    }

  } else {
    setDescontoCif(0);
    setDescontoFob(0);
    setPrecoFinalCif(precoRegraCif || 0);
    setPrecoFinalFob(precoRegraFob || 0);
  }

  if (!carregouPrecoAprovadoCliente) {
    setCarregouPrecoAprovadoCliente(aprovado);
  }

}, [
  precoCliente,
  faixa,
  condicaoEspecial,
  tipoCondicoes,
  produtoNaFilial?.id,
]);


  useEffect(() => {
    setShowOverlay({ fob: false, cif: false });
  }, [condicaoEspecial]);

  // Helper functions for processing data
  const createProdutoObject = (
    values,
    optProduto,
    filial,
    replicacao = false
  ) => {
    const grupoProduto = (gruposProduto || []).find((opt) => opt.id == values.grupoProdutoId);
    const prazoPagamento = (prazoPagamentos || []).find((opt) => opt.id == values.prazoPagamentoId);
    const familia = (familiasProdutoReplicacao || []).find((opt) => opt.id == optProduto.familiaId);

    if ((!familia || !familia?.replicacaoAtiva) && replicacao) {
      return null;
    }

    return {
      condicao: manterRegra ? "Manter no Regra" : faixa ? "Faixa" : "Condição Especial",
      precoFinal: { fob: values.precoFinalFob, cif: values.precoFinalCif },
      precoRegra: { fob: values.precoRegraFob, cif: values.precoRegraCif },
      desconto: { fob: values.descontoFob, cif: values.descontoCif },
      prazoPagamentoId: values.prazoPagamentoId ? values.prazoPagamentoId : null,
      prazoPagamento: prazoPagamento?.nome,
      enviaPrazoCif: values.prazoCif,
      enviaPrazoFob: values.prazoFob,
      grupoProdutoId: grupoProduto?.id,
      grupoProduto: grupoProduto?.nome,
      produtoId: values.produtoId,
      familiaId: optProduto.familiaId,
      produtoOriginal: optProduto,
      produto: optProduto?.descricaoProduto,
      codigo: optProduto?.codigo,
      filial: filial?.nome,
      filialId: filial?.id,
      enviadoAprovacao: !manterRegra ? false : true,
      quantidade: 1,
      grupoMaterialReplicacaoId: values.grupoProdutoReplicacaoBool ? (grupoProdutoReplicacaoSelect?.initValue || null) : null,
      subGrupoMaterialReplicacaoId: values.subGrupoMaterialReplicacaoBool ? (subGrupoMaterialSelect?.initValue || null) : null,
      produtoReplicacaoId: values.produtoReplicacaoBool ? (produtoReplicacaoSelect?.initValue || null) : null,
      grupoCentralizadorReplicacaoId: values.grupoCentralizadorReplicacaoBool ? (grupoCentralizadorSelect?.initValue || null) : null,
    };
  };

  const saveProdutoToLocalStorage = (produto, values, idCliente) => {
    const data = getLocalStorage("simulacao-" + idCliente, true);

    if (!produto) return;

    if (data && Object.keys(data).length > 0) {
      const indexGP = (data.gruposProduto || []).findIndex((opt) =>
        (opt.grupoProdutoId == values.grupoProdutoId || opt.grupoMaterialId == values.grupoProdutoId)
      );

      if (indexGP > -1) {
        const index = (data.gruposProduto[indexGP].produtos || []).findIndex(
          (opt) => opt.produtoId == values.produtoId && opt.filialId == produto.filialId
        );

        if (index > -1) {
          data.gruposProduto[indexGP].produtos[index] = produto;
        } else {
          data.gruposProduto[indexGP].produtos.push(produto);
        }
      } else if (Array.isArray(data.gruposProduto)) {
        data.gruposProduto.push({
          grupoProdutoId: values.grupoProdutoId,
          grupoMaterialId: values.grupoProdutoId,
          grupoProduto: produto.grupoProduto,
          produtos: [produto],
          status: 1,
        });
      } else {
        data.gruposProduto = [{
          grupoProdutoId: values.grupoProdutoId,
          grupoMaterialId: values.grupoProdutoId,
          grupoProduto: produto.grupoProduto,
          produtos: [produto],
          status: 1,
        }];
      }
      saveLocalStorage("simulacao-" + idCliente, data, true);
    } else {
      const simulacao = {
        createdAt: Date.now(),
        clienteId: idCliente,
        fracionamento: false,
        descargaManual: false,
        simulador: "ENSACADOS",
        gruposProduto: [{
          grupoProdutoId: values.grupoProdutoId,
          grupoMaterialId: values.grupoProdutoId,
          grupoProduto: produto.grupoProduto,
          produtos: [produto],
          status: 1,
        }],
      };
      saveLocalStorage("simulacao-" + idCliente, simulacao, true);
    }
  };

  // Form submission functions
  const processaProduto = async (values, optProduto, filial, replicacao = false) => {
    const produto = createProdutoObject(
      values,
      optProduto,
      filial,
      replicacao
    );

    if (produto) {
      saveProdutoToLocalStorage(produto, values, idCliente);
    }
  };

  const processGrupoProdutoReplication = async (values) => {
    const promises = [];

    precosRegraDisponiveis?.forEach(precoProdutoGrupo => {
      if (precoProdutoGrupo.filialId == locationData.filialId) {
        const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == precoProdutoGrupo.produtoId);
        const filial = (filiais || []).find((opt) => opt.id == precoProdutoGrupo.filialId);

        if (optProdutoReplicacao && optProdutoReplicacao.grupoMaterialId === grupoProdutoReplicacao && filial) {
          const promise = processaProduto({
            ...values,
            precoFinalFob: calculateDiscountFaixa(precoProdutoGrupo.valorPrecoFOB, descontoFob),
            precoFinalCif: calculateDiscountFaixa(precoProdutoGrupo.valorPrecoCIF, descontoCif),
            precoRegraFob: precoProdutoGrupo.valorPrecoFOB,
            precoRegraCif: precoProdutoGrupo.valorPrecoCIF,
            produtoId: precoProdutoGrupo.produtoId,
            grupoProdutoId: optProdutoReplicacao.grupoMaterialId
          }, optProdutoReplicacao, filial, true);
          promises.push(promise);
        }
      }
    });

    await Promise.all(promises);
  };

  const processSubGrupoMaterialReplication = async (values) => {
    const promises = [];

    precosRegraDisponiveis?.forEach(precoProdutoFimilia => {
      if (precoProdutoFimilia.filialId == locationData.filialId) {
        const optProdutoReplicacao = (produtosReplicacao || []).find((opt) => opt.id == precoProdutoFimilia.produtoId);
        const filial = (filiais || []).find((opt) => opt.id == precoProdutoFimilia.filialId);

        if (optProdutoReplicacao && optProdutoReplicacao.subGrupoMaterialId === subGrupoMaterialReplicacao && filial) {
          const promise = processaProduto({
            ...values,
            precoFinalFob: calculateDiscountFaixa(precoProdutoFimilia.valorPrecoFOB, descontoFob),
            precoFinalCif: calculateDiscountFaixa(precoProdutoFimilia.valorPrecoCIF, descontoCif),
            precoRegraFob: precoProdutoFimilia.valorPrecoFOB,
            precoRegraCif: precoProdutoFimilia.valorPrecoCIF,
            produtoId: precoProdutoFimilia.produtoId,
            grupoProdutoId: optProdutoReplicacao.grupoMaterialId
          }, optProdutoReplicacao, filial, true);
          promises.push(promise);
        }
      }
    });

    await Promise.all(promises);
  };





  const processaReplicacao = async (values) => {
    const replicationPromises = [];

    if (values.grupoProdutoReplicacaoBool && grupoProdutoReplicacao && precosRegraDisponiveis) {
      replicationPromises.push(processGrupoProdutoReplication(values));
    }

    if (values.subGrupoMaterialReplicacaoBool && subGrupoMaterialReplicacao && precosRegraDisponiveis) {
      replicationPromises.push(processSubGrupoMaterialReplication(values));
    }

    if (values.produtoReplicacaoBool && replicationData.produtoReplicacao && precosRegraDisponiveis) {
      replicationPromises.push(processProdutoReplication(values, replicationData,  precosRegraDisponiveis, produtosReplicacao, filiais, processaProduto, calculateDiscountFaixa,descontoFob, descontoCif));
    }

    if (values.centroReplicacaoBool && replicationData.filiaisReplicacao && precosRegraDisponiveis) {
      replicationPromises.push(processCentroReplication(values, precosRegraDisponiveis, replicationData, produtoSelecionado,precoFinalFob,precoFinalCif,  filiais, produtosReplicacao, processaProduto, descontoFob, descontoCif));
    }

    await Promise.all(replicationPromises);
  };

  const submitAddProduto = async (values) => {
    const optProduto = produtos?.find((opt) => opt.id == values.produtoId);
    const filial = filiais?.find((opt) => opt.id == produtoSimulacao.filialId);

    if (!filial) {
      setIsOpenModalResponse(true);
      return;
    }

    await processaProduto(values, optProduto, filial);
    await processaReplicacao(values);

    removeLocalStorage("produto-simulacao-nova-" + idCliente);
    navigate(`${initialPath}/simuladores/${idCliente}/simulacao`);
  };

  const handleSubmit = async (values) => {
    values.descontoFob = showOverlay.fob ? 0 : descontoFob;
    values.descontoCif = showOverlay.cif ? 0 : descontoCif;
    values.precoFinalFob = showOverlay.fob ? precoRegraFob : precoFinalFob;
    values.precoFinalCif = showOverlay.cif ? precoRegraCif : precoFinalCif;
    values.precoRegraFob = precoRegraFob;
    values.precoRegraCif = precoRegraCif;

    await submitAddProduto(values);
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validateOnBlur={true}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => (
        <>
          <Form id="formProduct">
            {loading ? (
              <div className="py-6 flex justify-center">
                <Spinner />
              </div>
            ) : (
              <>
                <ProductFormFields
                  optionFiliais={optionFiliais}
                  onChangeFilial={onChangeFilial}
                  filialSelect={filialSelect}
                  optionGruposProduto={optionGruposProduto}
                  onChangeGrupoProduto={onChangeGrupoProduto}
                  grupoProdutoSelect={grupoProdutoSelect}
                  optionProdutos={optionProdutos}
                  onChangeProduto={onChangeProduto}
                  produtoSelect={produtoSelect}
                  errors={errors}
                  touched={touched}
                />

                <ProposalTypeSection
                  clickProposta={handleProposalTypeClick}
                  manterRegra={manterRegra}
                  faixa={faixa}
                  condicaoEspecial={condicaoEspecial}
                  errors={errors}
                  touched={touched}
                />

                {/* Negociação - Layout Original */}
                <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
                  <div className="flex justify-between py-3">
                    <h2 className="text-2xl font-bold title pb-6">Negociação</h2>
                    <div className="ps-3">
                      {temSobreposicao && faixa && (
                        <p style={{ color: "red", fontSize: "14px" }}>{'Já existe uma Condição Especial aprovada para esse produto que sobrepõe os valores das demais negociações'}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-between items-center concorrente proposta gap-x-4 mt-4">
                    <div className="container mx-auto mt-4 p-4">
                      <div className="overflow-x-auto table-simulators">
                        <table className="w-full bg-white rounded-lg ">
                          <thead>
                            <tr>
                              <th className="p-2 sm:p-4 bg-header text-white">Preços</th>
                              <th className="p-2 sm:p-4 bg-header text-white">FOB</th>
                              <th className="p-2 sm:p-4 bg-header text-white">CIF</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="bg-row1">
                              <td className="p-2 sm:p-4 w-1/3">Preço Regra (R$/sc)</td>
                              <td className="p-2 sm:p-4 w-1/3">
                                <span className="block text-center">{money(precoRegraFob ?? 0)}</span>
                              </td>
                              <td className="p-2 sm:p-4 w-1/3">
                                <span className="block text-center">{money(precoRegraCif ?? 0)}</span>
                              </td>
                            </tr>
                            {!manterRegra && (
                              <>
                                {faixa && (
                                  <>
                                    <tr className="bg-row2">
                                      <td className="p-2 sm:p-4 w-1/3">Desconto Negociado</td>
                                      <td className="p-2 sm:p-4" colSpan={2}>
                                        <PercentageInput
                                          type={"default"}
                                          value={`${descontoFob}`}
                                          inputName="descontoFobCif"
                                          diff={true}
                                          input={descontoFob}
                                          min={-100}
                                          setInput={(e) => {
                                            setDescontoFob(e);
                                            setDescontoCif(e);
                                          }}
                                          onFocus={() => {
                                            setIsEditingDesconto(true);
                                            setIsEditingPrecoFinal(true);
                                          }}
                                          onBlur={() => {
                                            //setIsEditingDesconto(false);
                                          }}
                                          inputEditable
                                        />
                                      </td>
                                    </tr>
                                    <tr className="bg-row3">
                                      <td className="p-2 sm:p-4 w-1/3">Preço c/ Desconto (R$/sc)</td>
                                      <td className="p-2 sm:p-4 w-1/3">
                                        <span className="block text-center">{money(precoFinalFob)}</span>
                                      </td>
                                      <td className="p-2 sm:p-4 w-1/3">
                                        <span className="block text-center">{money(precoFinalCif)}</span>
                                      </td>
                                    </tr>
                                  </>
                                )}

                                {condicaoEspecial && (
                                  <>
                                    <tr className="bg-row2">
                                      <td className="p-2 sm:p-4 w-1/3">Desconto Negociado</td>

                                      <td className="p-2 sm:p-4 w-1/3">
                                        <PercentageSpc
                                          value={`${descontoFob}`}
                                          inputName="descontoFob"
                                          input={descontoFob}
                                          setInput={setDescontoFob}
                                          center={true}
                                          onFocus={() => {
                                            setIsEditingDesconto(true);
                                            setIsEditingPrecoFinal(false);
                                          }}
                                          onBlur={() => {
                                            setIsEditingDesconto(false);
                                          }}
                                        />

                                      </td>
                                      <td className="p-2 sm:p-4 w-1/3">

                                        <PercentageSpc
                                          value={`${descontoCif}`}
                                          inputName="descontoCif"
                                          input={descontoCif}
                                          setInput={setDescontoCif}
                                          center={true}
                                          onFocus={() => {
                                            setIsEditingDesconto(true);
                                            setIsEditingPrecoFinal(false);
                                          }}
                                          onBlur={() => {
                                            setIsEditingDesconto(false);
                                          }}
                                        />

                                      </td>
                                    </tr>
                                    <tr className="bg-row3">
                                      <td className="p-2 sm:p-4 w-1/3">Preço c/ Desconto (R$/sc)</td>
                                      <td className="p-2 sm:p-4 w-1/3">
                                        <div className="relative">
                                          <CurrencyInputAlternate
                                            type="text"
                                            inputName="precoFinalFob"
                                            input={precoFinalFob}
                                            setInput={setPrecoFinalFob}
                                            center={true}
                                            readOnly={!condicaoEspecial}
                                            onFocus={() => {
                                              setIsEditingDesconto(false);
                                              setIsEditingPrecoFinal(true);
                                            }}
                                            onBlur={() => {
                                              setIsEditingPrecoFinal(false);
                                            }}
                                          />

                                          {!showOverlay.fob && precoFinalFob !== 0 && (
                                            <div
                                              onClick={() => {
                                                setPrecoFinalFob(0);
                                                setDescontoFob(-100)
                                                setShowOverlay((prev) => ({
                                                  ...prev,
                                                  fob: true,
                                                }));
                                              }}
                                              className="absolute cursor-pointer right-0 top-0 h-full flex justify-center items-center z-[1]"
                                            >
                                              <TimesIcon fill="#000" />
                                            </div>
                                          )}

                                          {showOverlay.fob && (
                                            <NoInfoOverlay name="fob" setShowOverlay={setShowOverlay} />
                                          )}
                                        </div>
                                      </td>
                                      <td className="p-2 sm:p-4 w-1/3">
                                        <div className="relative">
                                          <CurrencyInputAlternate
                                            type="text"
                                            inputName="precoFinalCif"
                                            input={precoFinalCif}
                                            setInput={setPrecoFinalCif}
                                            center={true}
                                            readOnly={!condicaoEspecial}
                                            onFocus={() => {
                                              setIsEditingDesconto(false);
                                              setIsEditingPrecoFinal(true);
                                            }}
                                            onBlur={() => {
                                              setIsEditingPrecoFinal(false);
                                            }}
                                          />

                                          {!showOverlay.cif && precoFinalCif !== 0 && (
                                            <div
                                              onClick={() => {
                                                setPrecoFinalCif(0);
                                                setDescontoCif(-100)
                                                setShowOverlay((prev) => ({
                                                  ...prev,
                                                  cif: true,
                                                }));
                                              }}
                                              className="absolute cursor-pointer right-0 top-0 h-full flex justify-center items-center z-[1]"
                                            >
                                              <TimesIcon fill="#000" />
                                            </div>
                                          )}

                                          {showOverlay.cif && (
                                            <NoInfoOverlay name="cif" setShowOverlay={setShowOverlay} />
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {condicaoEspecial && (
                        <>
                          <div>
                            <div className="bg-primaria rounded-tr-lg rounded-tl-lg mt-10">
                              <p className="p-[16px] bg-header text-white font-bold">Prazo de Pagamento</p>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-x-5 p-4 items-center">
                              <p className="whitespace-nowrap">Prazo Diferenciado</p>
                              <div className="w-[100%] mt-4">
                                <Select
                                  name="prazoPagamentoId"
                                  label=""
                                  placeholder=""
                                  options={optionPrazosPagamento}
                                  noOptionsMessage="Prazo não encontrado"
                                  onChange={(e) => onChangePrazoPagamento(e)}
                                  errors={errors.prazoPagamentoId}
                                  touched={touched.prazoPagamentoId}
                                  {...prazoPagamentoSelect}
                                />
                              </div>

                              <div className="flex gap-x-4">
                                <div className="flex items-center gap-x-2">
                                  <label className="flex items-center space-x-2">
                                    <Checkbox name="prazoCif" onChange={(e) => { handleChangeEnviaPrazo(e, "cif") }} />
                                    <span className="text-lg font-bold">CIF</span>
                                  </label>
                                </div>
                                <div className="flex items-center gap-x-2">
                                  <label className="flex items-center space-x-2">
                                    <Checkbox name="prazoFob" onChange={(e) => { handleChangeEnviaPrazo(e, "fob") }} />
                                    <span className="text-lg font-bold">FOB</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Replicação para Faixa */}
                {faixa && (
                  <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
                    <div className="sm:flex justify-between py-3">
                      <h2 className="text-2xl font-bold title pb-6">Replicar Negociação</h2>
                    </div>
                    <div>
                      <div className="flex flex-col md:flex-row  gap-4 justify-between w-full">
                        <label className="flex items-center space-x-2">
                          <Field
                            type="checkbox"
                            name="grupoProdutoReplicacaoBool"
                            disabled={values.subGrupoMaterialReplicacaoBool || values.produtoReplicacaoBool}
                            className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                          />
                          <span className="font-bold text-lg">Grupo de produtos</span>
                        </label>
                        <div className="md:w-[70%] w-full">
                          <Select
                            name="grupoProdutoReplicacaoId"
                            label=""
                            placeholder=""
                            options={optionGruposProdutoReplicacao}
                            noOptionsMessage="Grupo de produto não encontrado"
                            onChange={(e) => onChangeGrupoProdutoReplicacao(e)}
                            errors={errors.grupoProdutoReplicacaoId}
                            touched={touched.grupoProdutoReplicacaoId}
                            isDisabled={!values.grupoProdutoReplicacaoBool}
                            {...grupoProdutoReplicacaoSelect}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col md:flex-row  gap-4 justify-between w-full">
                        <label className="flex items-center space-x-2">
                          <Field
                            type="checkbox"
                            name="subGrupoMaterialReplicacaoBool"
                            disabled={values.grupoProdutoReplicacaoBool || values.produtoReplicacaoBool}
                            className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                          />
                          <span className="font-bold text-lg">SubGrupo de Produto</span>
                        </label>
                        <div className="md:w-[70%] w-full">
                          <Select
                            name="subGrupoMaterialReplicacaoId"
                            label=""
                            placeholder=""
                            options={optionSubGrupoMateriais}
                            noOptionsMessage="Familia de produto não encontrada"
                            onChange={(e) => onChangeSubGrupoMaterial(e)}
                            errors={errors.subGrupoMaterialReplicacaoId}
                            touched={touched.subGrupoMaterialReplicacaoId}
                            isDisabled={!values.subGrupoMaterialReplicacaoBool}
                            {...subGrupoMaterialSelect}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col md:flex-row  gap-4 justify-between w-full">
                        <label className="flex items-center space-x-2">
                          <Field
                            type="checkbox"
                            name="produtoReplicacaoBool"
                            disabled={values.subGrupoMaterialReplicacaoBool || values.grupoProdutoReplicacaoBool}
                            className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                          />
                          <span className="font-bold text-lg">Produto</span>
                        </label>
                        <div className="md:w-[70%] w-full">
                          <Multiselect
                            name="produtoReplicacaoId"
                            options={optionReplicacaoProdutos}
                            selectedValues={initialValues.produtos}
                            placeholder=""
                            showArrow
                            customArrow={true}
                            displayValue="label"
                            disable={!values.produtoReplicacaoBool}
                            emptyRecordMsg="Produto não encontrado"
                            onRemove={handleProdutoReplicacaoMulti}
                            onSelect={handleProdutoReplicacaoMulti}
                          />
                        </div>
                      </div>
                      <div className="flex flex-col md:flex-row  gap-4 justify-between w-full">
                        <label className="flex items-center space-x-2">
                          <Field
                            type="checkbox"
                            name="grupoCentralizadorReplicacaoBool"
                            className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                          />
                          <span className="font-bold text-lg">Grupo Centralizador</span>
                        </label>
                        <div className="md:w-[70%] w-full">
                          <Select
                            name="grupoCentralizadorReplicacaoId"
                            label=""
                            placeholder=""
                            options={optionGruposCentralizadores}
                            noOptionsMessage="Grupo centralizador não encontrado"
                            onChange={(e) => onChangeGrupoCentralizador(e)}
                            errors={errors.grupoCentralizadorReplicacaoId}
                            touched={touched.grupoCentralizadorReplicacaoId}
                            isDisabled={!values.grupoCentralizadorReplicacaoBool}
                            {...grupoCentralizadorSelect}
                          />
                        </div>
                      </div>
                      {errors.grupoCentralizadorReplicacaoId && (
                        <p style={{ color: "red" }}>{errors.grupoCentralizadorReplicacaoId}</p>
                      )}
                    </div>
                  </div>
                )}

                {/* Replicação para Condição Especial */}
                {condicaoEspecial && (
                  <div className="containerForm container bg-white p-7 rounded-lg mt-4 relative">
                    <div className="sm:flex justify-between py-3">
                      <h2 className="text-2xl font-bold title pb-6">Replicar Negociação</h2>
                    </div>
                    <div>
                      <div className="flex flex-col md:flex-row  gap-4 justify-between w-full">
                        <label className="flex items-center space-x-2">
                          <Field
                            type="checkbox"
                            name="centroReplicacaoBool"
                            className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                          />
                          <span className="font-bold text-lg">Centro</span>
                        </label>
                        <div className="md:w-[70%] w-full">
                          <Multiselect
                            name="filialReplicacaoId"
                            options={optionFiliaisReplicacao}
                            selectedValues={initialValues.centros}
                            placeholder=""
                            showArrow
                            customArrow={true}
                            displayValue="label"
                            disable={!values.centroReplicacaoBool}
                            emptyRecordMsg="Nenhum centro não encontrado"
                            onRemove={handleFilialReplicacaoMulti}
                            onSelect={handleFilialReplicacaoMulti}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </Form>

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />
          <ModalCreateProduct
            isOpen={isModalOpenPrice}
            onClose={closeModalPrice}
            title="Aviso!"
            sub={
              <>
                <p className="font-bold max-w-[400px]">Esta condição especial irá sobrepor a fixa</p>
                <p className="font-bold  center mt-4">Deseja continuar ?</p>
              </>
            }
            buttonOne="Não"
            buttonTwo="Sim"
            linkOne={null}
            linkTwo={null}
          />
          <ModalResponse
            isOpen={isOpenModalResponse}
            status="warning"
            message="Não foi possível definir o centro/filial dessa simulação"
            submessage={<>Houve um erro ao definir o centro/filial da atual simulação, <br />tente <b>sincronizar os dados e recarregar a página</b>. <br />Caso o erro persista, contate o suporte.</>}
            closeModal={() => {
              setIsOpenModalResponse(false);
            }}
          />
        </>
      )}
    </Formik>
  );
};

export default NovoProdutoFormulario;